declare var require: any

import confetti from 'canvas-confetti';

const SOUND_A = require('../audio/a.mp3');
const SOUND_B = require('../audio/b.mp3');
const SOUND_C = require('../audio/c.mp3');
const SOUND_D = require('../audio/d.mp3');
const SOUND_E = require('../audio/e.mp3');
const SOUND_F = require('../audio/f.mp3');
const SOUND_G = require('../audio/g.mp3');
const SOUND_H = require('../audio/h.mp3');
const SOUND_I = require('../audio/i.mp3');
const SOUND_J = require('../audio/j.mp3');
const SOUND_K = require('../audio/k.mp3');
const SOUND_L = require('../audio/l.mp3');
const SOUND_M = require('../audio/m.mp3');
const SOUND_N = require('../audio/n.mp3');
const SOUND_O = require('../audio/o.mp3');
const SOUND_P = require('../audio/p.mp3');
const SOUND_Q = require('../audio/q.mp3');
const SOUND_R = require('../audio/r.mp3');
const SOUND_S = require('../audio/s.mp3');
const SOUND_T = require('../audio/t.mp3');
const SOUND_U = require('../audio/u.mp3');
const SOUND_V = require('../audio/v.mp3');
const SOUND_W = require('../audio/w.mp3');
const SOUND_X = require('../audio/x.mp3');
const SOUND_Y = require('../audio/y.mp3');
const SOUND_Z = require('../audio/z.mp3');

const app = document.querySelector('#game');

const alphabetsGame = function(host: HTMLElement) {

  const soundLibrary = function(letter: string) {
    const sound: { [key: string]: string } = {
      'a': SOUND_A,
      'b': SOUND_B,
      'c': SOUND_C,
      'd': SOUND_D,
      'e': SOUND_E,
      'f': SOUND_F,
      'g': SOUND_G,
      'h': SOUND_H,
      'i': SOUND_I,
      'j': SOUND_J,
      'k': SOUND_K,
      'l': SOUND_L,
      'm': SOUND_M,
      'n': SOUND_N,
      'o': SOUND_O,
      'p': SOUND_P,
      'q': SOUND_Q,
      'r': SOUND_R,
      's': SOUND_S,
      't': SOUND_T,
      'u': SOUND_U,
      'v': SOUND_V,
      'w': SOUND_W,
      'x': SOUND_X,
      'y': SOUND_Y,
      'z': SOUND_Z
    }
    return sound[letter]
  }

  const render = function(): Promise<void> {
    return new Promise(function(resolve, reject) {
      const letters = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
      const colors = [
        { background: '#ffc300', color: '#483909' },
        { background: '#daf7a6', color: '#138000' },
        { background: '#3f51b5', color: '#b8c3ff' },
        { background: '#f1948a', color: '#a71809' },
        { background: '#00305C', color: '#85c1e9' },
        { background: '#03a9f4', color: '#00305c' },
        { background: '#ff5722', color: '#fffaca' },
        { background: '#795548', color: '#ffd6c7' },
        { background: '#e91e63', color: '#ffe4ed' },
        { background: '#f44336', color: '#fffaca' },
        { background: '#138000', color: '#f2ffca' }
      ];
      const randomLetter = Math.floor(Math.random() * letters.length);
      const randomColor = Math.floor(Math.random() * colors.length);
      host.innerHTML = '';
      host.innerHTML = `
        <div style="background: ${colors[randomColor].background}; color: ${colors[randomColor].color};" class="screen" id="screen">
          <h1 class="letter">${letters[randomLetter]}</h1>
          <audio src="${soundLibrary(letters[randomLetter])}" id="sound" style="display: none;" controls autoplay></audio>
        </div>
      `;
      confetti({
        spread: 1000,
        particleCount: 50,
        origin: { y: 0.3 }
      });
      resolve();
    });
  }

  const bindEvents = function() {
    host.addEventListener('click', function(event: Event) {
      event.preventDefault();
      const element = event.target as any;
      if (element.closest('.screen') !== null) {
        render();
      }
    });
  }

  const init = function() {
    render();
  }

  return {
    init: init,
    bindEvents: bindEvents
  }
}

const targetElement = document.querySelector('#app') as HTMLElement;

if (targetElement !== null) {
  const app = alphabetsGame(targetElement);
  app.init();
  app.bindEvents();
}